// FIXME: Type onError and onSuccess. Typeparamater generics function yes or no? Is this really best practise.
// Look at typesafe io in typescript. e.g. io-ts. What we have is partly typesafe.
export function fetchData(url, method, onSuccess, onError, authObject, body) {
    if (authObject.apiKey && authObject.accessToken) {
        fetch(url, {
            method: method,
            headers: {
                "x-api-key": authObject.apiKey,
                Authorization: `Bearer ${authObject.accessToken}`,
                "content-type": "application/x-www-form-urlencoded",
            },
            credentials: "omit",
            body: body ? JSON.stringify(body) : undefined,
        })
            .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
            .then(onSuccess)
            .catch(onError);
    }
    else {
        fetch(url, {
            method: method,
            credentials: "include",
            body: body ? JSON.stringify(body) : undefined,
        })
            .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
            .then(onSuccess)
            .catch(onError);
    }
}
export function fetchDataAsGeoJSON(url, method, onSuccess, onError, authObject, body) {
    if (authObject.apiKey && authObject.accessToken) {
        fetch(url, {
            method: method,
            headers: {
                Accept: "application/geo+json",
                "x-api-key": authObject.apiKey,
                Authorization: `Bearer ${authObject.accessToken}`,
            },
            credentials: "omit",
            body: body ? JSON.stringify(body) : undefined,
        })
            .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
            .then(onSuccess)
            .catch(onError);
    }
    else {
        fetch(url, {
            method: method,
            headers: {
                Accept: "application/geo+json",
            },
            credentials: "include",
        })
            .then((response) => {
            response.json().then(onSuccess).catch(onError);
        })
            .catch(onError);
    }
}
// FIXME: fetchFn is passed because of mock test, this should not be the case, why is this?
// FIXME: There might be an bug, that if you get 500 while paging on one, no error happens.
//        Yes, there is on GraphService:343. Fix it.
export function fetchAllData(fetchFn, url, method, onSuccess, onError, baseURL, authObject, body) {
    fetchFn(url, method, (data) => {
        if (data === undefined || data.value === undefined || !Array.isArray(data.value)) {
            onError(Error("Data is invalid."));
            return;
        }
        if (data.next) {
            fetchAllData(fetchFn, `${baseURL}${data.next}`, method, (nextData) => {
                onSuccess(data.value.concat(nextData));
            }, onError, baseURL, authObject, body);
        }
        else {
            onSuccess(data.value);
        }
    }, onError, authObject, body);
}
export function fetchAllDataAsGeoJSON(fetchFn, url, method, onSuccess, onError, baseURL, authObject, body) {
    fetchFn(url, method, (data) => {
        if (data === undefined || !(data.value.type == "FeatureCollection")) {
            onError(Error("Data is invalid."));
            return;
        }
        if (data.next) {
            fetchAllDataAsGeoJSON(fetchFn, `${baseURL}${data.next}`, method, (nextData) => {
                const concated_features = data.value.features.concat(nextData.features);
                data.value.features = concated_features;
                onSuccess(data.value);
            }, onError, baseURL, authObject, body);
        }
        else {
            onSuccess(data.value);
        }
    }, onError, authObject, body);
}
export function isValidSchema(object, keys) {
    const keysIs = Object.keys(object);
    for (const key of keys) {
        if (keysIs.indexOf(key) === -1) {
            return false;
        }
    }
    return true;
}
export function notnestedframefields() {
    const schema = [
        "id",
        "stream",
        "streamtype",
        "segment",
        "framenumber",
        "projection",
        "timestamp",
        "images",
        "playmode",
        "easting",
        "northing",
        "height",
        "epsg",
        "omega",
        "phi",
        "kappa",
        "capturesystemID",
        "framedatametaID",
        "campaignID",
        "precOmega",
        "precPhi",
        "precKappa",
        "precEasting",
        "precNorthing",
        "precHeight",
    ];
    return `fields=${schema.join(",")}`;
}
export function getOriginFromURL(url) {
    try {
        const url_obj = new URL(url);
        return url_obj.origin;
    }
    catch (e) {
        return "";
    }
}
//# sourceMappingURL=util.js.map